import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const postEditingStateSelector = (state: RootState) => state.postEditing;

export const selectorEditingPostId = createSelector(
	postEditingStateSelector,
	(state) => state.editingPostId,
);
